import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface MinimalLayoutProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

const MinimalLayout: React.FC<MinimalLayoutProps> = ({ children, noPadding }) => {
  console.log('Rendering MinimalLayout component with enhanced footer navigation', { noPadding });
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className={`flex-grow pt-20 ${noPadding ? '' : 'w-full'}`}>
        {noPadding ? (
          children
        ) : (
          <div className="w-full h-full">
             {children}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default MinimalLayout; 